import dayjs from "dayjs";
import type { AppMyStoreOrderRow } from "./StoreOrderType";

export const H5_PAY_PENDING_MESSAGE =
  "在线支付接入中，如需支付订单请联系老管助理";

/** 仅保留近 3 年内的订单（按下单时间） */
export function filterOrdersWithinThreeYears(rows: AppMyStoreOrderRow[]): AppMyStoreOrderRow[] {
  const cutoff = dayjs().subtract(3, "year");
  return rows.filter((row) => {
    const created = dayjs(formatOrderDate(row.createdAt));
    return created.isValid() && !created.isBefore(cutoff, "day");
  });
}

function formatOrderDate(v: unknown): string {
  if (v instanceof Date) {
    const y = v.getFullYear();
    const m = String(v.getMonth() + 1).padStart(2, "0");
    const d = String(v.getDate()).padStart(2, "0");
    const h = String(v.getHours()).padStart(2, "0");
    const min = String(v.getMinutes()).padStart(2, "0");
    const s = String(v.getSeconds()).padStart(2, "0");
    return `${y}-${m}-${d} ${h}:${min}:${s}`;
  }
  if (typeof v === "string") {
    return v.trim();
  }
  return "";
}

export function isUnpaidStoreOrder(row: AppMyStoreOrderRow): boolean {
  return row.displayStatus === "unpaid";
}

export function isCancelledStoreOrder(row: AppMyStoreOrderRow): boolean {
  return row.displayStatus === "cancelled";
}

/** 我的订单列表：订单状态样式类名 */
export function resolveStoreOrderStatusClass(row: AppMyStoreOrderRow): string {
  if (isUnpaidStoreOrder(row)) {
    return "space-mine-orders__status space-mine-orders__status--unpaid";
  }
  if (isCancelledStoreOrder(row)) {
    return "space-mine-orders__status space-mine-orders__status--cancelled";
  }
  return "space-mine-orders__status space-mine-orders__status--paid";
}

/** 订单列表：规格/档位展示文案 */
export function formatOrderSpecLabel(row: AppMyStoreOrderRow): string {
  const sub = row.subProductName?.trim();
  if (sub) {
    return `${row.serviceTierLabel} · ${sub}`;
  }
  return row.serviceTierLabel;
}
